var _path, _line, _polyline, _polyline2, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourtesyCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 565 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535,175.4c-1.5-2-3.2-3.8-5.1-5.4l-55.9-48.6c-2.1-1.9-4.1-4-5.7-6.3-13.5-18.9-33.9-62-33.9-62-9.6-19.1-29.3-27.8-39.4-31.2-3.6-1.2-7.4-1.8-11.2-1.8h-204.6c-3.8,0-7.6.6-11.2,1.8-10.1,3.3-29.8,12.1-39.4,31.2,0,0-20.4,43.1-33.9,62-1.7,2.3-3.6,4.4-5.7,6.3l-55.9,48.6c-1.9,1.6-3.6,3.4-5.1,5.4-4.9,6.6-14,21.6-14,43.7v85.9c0,4.6.8,9.1,2.5,13.3,3.3,8.4,10.6,20.4,25,21.9,1,.1,1.9.1,2.9.1h237s237,0,237,0c1,0,2,0,2.9-.1,14.4-1.5,21.7-13.5,25-21.9,1.7-4.2,2.5-8.8,2.5-13.3v-85.9c0-22.1-9.1-37.2-14-43.7Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 105.8,
    x2: 463.3,
    y2: 105.8,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "53.2 152.6 126 183.6 153.7 211.3 257 211.3 282.6 236.9",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "510.6 152.6 437.8 183.6 410.1 211.3 306.8 211.3 281.1 236.9",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.1,190.7l-.6.7c-9.1,11.7-23.1,18.5-37.9,18.5h-39c-10.2,0-20.3-3.1-28.4-9.3s-7.2-6.4-7.8-9.9",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M430.6,190.7l.6.7c9.1,11.7,23.1,18.5,37.9,18.5h39c10.2,0,20.3-3.1,28.4-9.3s7.2-6.4,7.8-9.9",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14,251s76.4-6.8,84.3,16.9",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6,250.1s-.5,8.9,1,18.8c2.2,14.6,14.5,25.5,29.2,26.5,6.4.4,14.8.6,25.9.2",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M549,251s-76.4-6.8-84.3,16.9",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M523.4,250.1s.5,8.9-1,18.8c-2.2,14.6-14.5,25.5-29.2,26.5-6.4.4-14.8.6-25.9.2",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.6,341.1l19.9-21.8c11.1-10.2,24.9-15.7,39.2-15.7h107.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.2,341.1l-19.9-21.8c-11.1-10.2-24.9-15.7-39.2-15.7h-107.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.1,340.5v42.6c0,11.7-9.1,21.2-20.2,21.2h-61c-11.1,0-20.2-9.6-20.2-21.2v-71",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M446.9,340.5v42.6c0,11.7,9.1,21.2,20.2,21.2h61c11.1,0,20.2-9.6,20.2-21.2v-71",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8,112.4l-40.3-6.6c-3,0-5.5-2.5-5.5-5.5v-20.6c0-3,2.5-5.5,5.5-5.5h40.3c3,0,5.5,2.5,5.5,5.5v27.1c0,3-2.5,5.5-5.5,5.5Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M468.9,112.4l40.3-6.6c3,0,5.5-2.5,5.5-5.5v-20.6c0-3-2.5-5.5-5.5-5.5h-40.3c-3,0-5.5,2.5-5.5,5.5v27.1c0,3,2.5,5.5,5.5,5.5Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtesyCarIcon);
export default __webpack_public_path__ + "static/media/courtesy-car-icon.9c6246283e8cab511d3b4b48ee1350e5.svg";
export { ForwardRef as ReactComponent };